/* Aurea — comportamento del tema. Nessuna dipendenza: gli eventi sono delegati al documento,
   così le parti ridisegnate dalla Section Rendering API non vanno ricollegate. */
(function () {
  'use strict';

  var tema = window.tema || { testi: {} };
  var rotte = window.routes || {};
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var movimentoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tutti(selettore, radice) {
    return Array.prototype.slice.call((radice || document).querySelectorAll(selettore));
  }

  /* L'avviso in basso: un testo e, se serve, un'azione. Resta un po' di piu'
     quando c'e' qualcosa da premere. */
  function avvisa(testo, azione, lungo) {
    var avviso = document.querySelector('.avviso-flottante');
    if (!avviso || !testo) return;
    avviso.classList.toggle('avviso-flottante--lungo', !!lungo);
    avviso.textContent = '';
    avviso.appendChild(document.createTextNode(testo));
    if (azione) {
      var pulsante = document.createElement('button');
      pulsante.type = 'button';
      pulsante.className = 'avviso-flottante__azione';
      pulsante.textContent = azione.testo;
      pulsante.addEventListener('click', function () {
        avviso.hidden = true;
        clearTimeout(avvisa.timer);
        azione.esegui();
      });
      avviso.appendChild(pulsante);
    }
    avviso.hidden = false;
    clearTimeout(avvisa.timer);
    avvisa.timer = setTimeout(function () { avviso.hidden = true; }, azione ? 5200 : 3200);
  }

  function html(testo) {
    return new DOMParser().parseFromString(testo, 'text/html');
  }

  /* ---------- comparsa delle sezioni ---------- */

  function rivela(radice) {
    var elementi = tutti('.rivela:not(.visibile), .svela:not(.visibile)', radice);
    if (inEditor || movimentoRidotto || !('IntersectionObserver' in window)) {
      elementi.forEach(function (e) { e.classList.add('visibile'); });
      return;
    }
    /* Chi si svela parte ritagliato del tutto, e un elemento ritagliato non "entra" mai nella vista:
       si osserva il suo contenitore. */
    var gruppi = new Map();
    var osservatore = new IntersectionObserver(function (voci) {
      voci.forEach(function (voce) {
        if (voce.isIntersecting) {
          (gruppi.get(voce.target) || []).forEach(function (e) { e.classList.add('visibile'); });
          osservatore.unobserve(voce.target);
        }
      });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.05 });
    elementi.forEach(function (e) {
      var bersaglio = e.classList.contains('svela') && e.parentElement ? e.parentElement : e;
      if (!gruppi.has(bersaglio)) { gruppi.set(bersaglio, []); osservatore.observe(bersaglio); }
      gruppi.get(bersaglio).push(e);
    });
  }

  /* ---------- annunci a rotazione ---------- */

  function annunci(radice) {
    tutti('[data-annunci]', radice).forEach(function (barra) {
      var testi = tutti('.annunci__testo', barra);
      if (testi.length < 2 || movimentoRidotto || barra.dataset.avviata) return;
      barra.dataset.avviata = '1';
      var attuale = 0;
      setInterval(function () {
        if (barra.matches(':hover')) return;
        testi[attuale].classList.remove('attivo');
        attuale = (attuale + 1) % testi.length;
        testi[attuale].classList.add('attivo');
      }, 5000);
    });
  }

  /* ---------- pannelli laterali ---------- */

  var ultimoFuoco = null;

  function apriPannello(pannello) {
    if (!pannello) return;
    ultimoFuoco = document.activeElement;
    pannello.hidden = false;
    document.body.classList.add('blocca-scorrimento');
    var corpo = pannello.querySelector('[tabindex="-1"]') || pannello.querySelector('button, a');
    if (corpo) corpo.focus();
  }

  /* Il tabulatore gira dentro il pannello aperto: fuori c'e' solo il velo. */
  function trattieniFuoco(e) {
    if (e.key !== 'Tab') return;
    var pannello = document.querySelector('[data-menu-mobile]:not([hidden]), [data-pannello-carrello]:not([hidden])');
    if (!pannello) return;
    var attivi = tutti('a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex="0"]', pannello)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!attivi.length) return;
    var primo = attivi[0], ultimo = attivi[attivi.length - 1];
    if (e.shiftKey && (document.activeElement === primo || !pannello.contains(document.activeElement))) {
      e.preventDefault(); ultimo.focus();
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault(); primo.focus();
    }
  }

  function chiudiPannelli() {
    tutti('[data-menu-mobile], [data-pannello-carrello]').forEach(function (p) { p.hidden = true; });
    tutti('[data-apri-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('blocca-scorrimento');
    if (ultimoFuoco && ultimoFuoco.focus) ultimoFuoco.focus();
  }

  /* ---------- concierge ---------- */

  function concierge() { return document.querySelector('[data-concierge]'); }

  function apriConcierge(messaggio) {
    var c = concierge();
    if (!c) return;
    var pannello = c.querySelector('.concierge__pannello');
    var pulsante = c.querySelector('[data-apri-concierge]');
    /* Da una pagina prodotto il messaggio arriva gia' scritto, con il nome del prodotto. */
    var whatsapp = c.querySelector('[data-concierge-whatsapp]');
    var email = c.querySelector('[data-concierge-email]');
    if (whatsapp) {
      whatsapp.dataset.base = whatsapp.dataset.base || whatsapp.getAttribute('href');
      whatsapp.setAttribute('href', messaggio ? whatsapp.dataset.base + '?text=' + encodeURIComponent(messaggio) : whatsapp.dataset.base);
    }
    if (email) {
      email.dataset.base = email.dataset.base || email.getAttribute('href');
      email.setAttribute('href', messaggio ? email.dataset.base + '?subject=' + encodeURIComponent(messaggio) : email.dataset.base);
    }
    pannello.hidden = false;
    c.classList.add('aperto');
    var consiglio = pannello.querySelector('[data-guida]');
    if (consiglio && consiglio.apri) consiglio.apri();
    if (pulsante) pulsante.setAttribute('aria-expanded', 'true');
    var campo = pannello.querySelector('[data-chat-campo]');
    if (campo) {
      /* Con l'assistente, il messaggio gia' scritto finisce nel campo: basta premere invio. */
      if (messaggio && !campo.value) { campo.value = messaggio; campo.dispatchEvent(new Event('input')); }
      var messaggi = pannello.querySelector('[data-chat-messaggi]');
      if (messaggi) messaggi.scrollTop = messaggi.scrollHeight;
      campo.focus();
      return;
    }
    var primo = pannello.querySelector('a, button');
    if (primo) primo.focus();
  }

  function chiudiConcierge() {
    var c = concierge();
    if (!c || !c.classList.contains('aperto')) return;
    c.querySelector('.concierge__pannello').hidden = true;
    c.classList.remove('aperto');
    var pulsante = c.querySelector('[data-apri-concierge]');
    if (pulsante) { pulsante.setAttribute('aria-expanded', 'false'); pulsante.focus(); }
  }

  /* Un benvenuto, una volta per visita, qualche secondo dopo l'arrivo: come chi ti saluta entrando. */
  function benvenuto() {
    var c = concierge();
    if (!c || !c.dataset.benvenuto || inEditor) return;
    try {
      if (sessionStorage.getItem('aurea-benvenuto')) return;
      sessionStorage.setItem('aurea-benvenuto', '1');
    } catch (e) { return; }
    setTimeout(function () {
      if (c.classList.contains('aperto')) return;
      avvisa(c.dataset.benvenuto, { testo: c.querySelector('.concierge__etichetta').textContent, esegui: function () { apriConcierge(); } }, true);
    }, 5000);
  }

  /* ---------- l'assistente: una conversazione nel pannello ---------- */

  /* Parla con il servizio nella cartella assistente/ del tema, che gira sul server del negozio
     con un modello locale. Le risposte arrivano parola per parola; i prodotti nominati diventano
     schede. La conversazione resta per la visita (sessionStorage), cosi' cambiando pagina continua. */
  function prodottoAttuale() {
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/);
    return m ? m[1] : '';
  }

  function assistente(radice) {
    var chat = (radice || document).querySelector('[data-chat]');
    if (!chat || chat.dataset.pronto || !chat.dataset.chatUrl) return;
    chat.dataset.pronto = '1';
    var t = tema.testi.chat || {};
    var url = chat.dataset.chatUrl.replace(/\/+$/, '');
    var lista = chat.querySelector('[data-chat-messaggi]');
    var form = chat.querySelector('[data-chat-form]');
    var campo = chat.querySelector('[data-chat-campo]');
    var invio = form.querySelector('[type="submit"]');
    var spunti = chat.querySelector('[data-chat-spunti]');
    var nota = chat.querySelector('.chat__nota');
    var storia = [];
    var occupato = false;
    try { storia = JSON.parse(sessionStorage.getItem('aurea-chat') || '[]'); } catch (e) { storia = []; }
    if (!Array.isArray(storia)) storia = [];

    function salva() {
      storia = storia.slice(-12);
      try { sessionStorage.setItem('aurea-chat', JSON.stringify(storia)); } catch (e) { /* senza memoria, la chat vive solo in pagina */ }
    }

    function scorri() { lista.scrollTop = lista.scrollHeight; }

    function bolla(ruolo) {
      var b = document.createElement('div');
      b.className = 'chat__bolla chat__bolla--' + ruolo;
      var chi = document.createElement('span');
      chi.className = 'chat__chi';
      chi.textContent = ruolo === 'utente' ? t.tu : t.atelier;
      var testo = document.createElement('div');
      testo.className = 'chat__testo';
      b.appendChild(chi);
      b.appendChild(testo);
      lista.appendChild(b);
      return b;
    }

    /* Dal modello arriva testo semplice con **grassetto** e codici [[prodotto]]: i codici spariscono
       (diventano schede), il grassetto resta, niente altro viene interpretato. */
    function formatta(el, testo) {
      el.textContent = '';
      var pulito = testo.replace(/\s*\[\[[a-z0-9-]*\]?\]?\s*$/, '').replace(/\s*\[\[[a-z0-9-]+\]\]/g, '');
      pulito.split(/(\*\*[^*]+\*\*)/).forEach(function (parte) {
        if (/^\*\*[^*]+\*\*$/.test(parte)) {
          var forte = document.createElement('strong');
          forte.textContent = parte.slice(2, -2);
          el.appendChild(forte);
          return;
        }
        parte.split('\n').forEach(function (riga, i) {
          if (i) el.appendChild(document.createElement('br'));
          el.appendChild(document.createTextNode(riga));
        });
      });
    }

    function schede(b, prodotti) {
      if (!prodotti || !prodotti.length) return;
      var griglia = document.createElement('div');
      griglia.className = 'chat__schede';
      prodotti.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'chat__scheda';
        a.href = p.url;
        var img = document.createElement('img');
        img.src = p.immagine || '';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 48; img.height = 48;
        img.onerror = function () { this.style.visibility = 'hidden'; };
        var testo = document.createElement('span');
        var titolo = document.createElement('span');
        titolo.className = 'chat__scheda-titolo';
        titolo.textContent = p.titolo;
        var prezzo = document.createElement('span');
        prezzo.className = 'chat__scheda-prezzo';
        prezzo.textContent = p.disponibile === false ? t.esaurito : p.prezzo;
        testo.appendChild(titolo); testo.appendChild(prezzo);
        var vedi = document.createElement('span');
        vedi.className = 'chat__scheda-vedi';
        vedi.textContent = t.vedi;
        a.appendChild(img); a.appendChild(testo); a.appendChild(vedi);
        griglia.appendChild(a);
      });
      b.appendChild(griglia);
    }

    function contattoAlternativo(el) {
      var whatsapp = document.querySelector('[data-concierge-whatsapp]');
      var email = document.querySelector('[data-concierge-email]');
      var link = whatsapp || email;
      if (!link) return;
      el.appendChild(document.createTextNode(' '));
      var a = document.createElement('a');
      a.href = link.dataset.base || link.getAttribute('href');
      a.textContent = link.textContent.trim();
      if (whatsapp) { a.target = '_blank'; a.rel = 'noopener'; }
      el.appendChild(a);
    }

    function aggiornaRicomincia() {
      var vecchio = chat.querySelector('.chat__ricomincia');
      if (vecchio) vecchio.remove();
      if (!storia.length || !nota) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'chat__ricomincia';
      b.textContent = t.ricomincia;
      b.addEventListener('click', function () {
        storia = [];
        salva();
        lista.textContent = '';
        mostraStoria();
        campo.focus();
      });
      nota.appendChild(b);
    }

    function mostraStoria() {
      if (!storia.length && chat.dataset.chatIntro) formatta(bolla('assistente').querySelector('.chat__testo'), chat.dataset.chatIntro);
      storia.forEach(function (m) {
        var b = bolla(m.ruolo);
        formatta(b.querySelector('.chat__testo'), m.testo);
        schede(b, m.prodotti);
      });
      if (spunti) spunti.hidden = storia.length > 0;
      aggiornaRicomincia();
      scorri();
    }

    function leggiFlusso(risposta, alPezzo) {
      var lettore = risposta.body.getReader();
      var decodifica = new TextDecoder();
      var resto = '';
      var esito = { testo: '', prodotti: [] };
      function tratta(blocco) {
        var riga = blocco.split('\n').filter(function (r) { return r.indexOf('data:') === 0; })[0];
        if (!riga) return;
        var dati = JSON.parse(riga.slice(5));
        if (dati.errore) throw new Error(dati.errore);
        if (dati.t) { esito.testo += dati.t; alPezzo(esito.testo); }
        if (dati.fine) esito.prodotti = dati.prodotti || [];
      }
      function passo() {
        return lettore.read().then(function (r) {
          if (r.done) { if (resto.trim()) tratta(resto); return esito; }
          resto += decodifica.decode(r.value, { stream: true });
          var blocchi = resto.split('\n\n');
          resto = blocchi.pop();
          blocchi.forEach(tratta);
          return passo();
        });
      }
      return passo();
    }

    function invia(testo) {
      testo = (testo || '').trim();
      if (!testo || occupato) return;
      occupato = true;
      invio.disabled = true;
      if (spunti) spunti.hidden = true;
      storia.push({ ruolo: 'utente', testo: testo });
      salva();
      formatta(bolla('utente').querySelector('.chat__testo'), testo);
      campo.value = '';
      campo.style.height = '';
      var b = bolla('assistente');
      b.classList.add('chat__bolla--penso');
      var el = b.querySelector('.chat__testo');
      el.innerHTML = '<span class="chat__puntini"><i></i><i></i><i></i></span>';
      scorri();
      /* Un modello su CPU puo' metterci qualche secondo: dopo un po' lo si dice, cosi' nessuno pensa che si sia bloccato. */
      var attesa = setTimeout(function () {
        if (b.classList.contains('chat__bolla--penso')) { el.textContent = t.penso; scorri(); }
      }, 6000);

      var richiesta;
      try {
        richiesta = fetch(url + '/chat', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ messaggi: storia, pagina: { prodotto: prodottoAttuale() } })
        });
      } catch (e) { richiesta = Promise.reject(e); }

      richiesta.then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            var errore = new Error(d.errore || r.status);
            errore.stato = r.status;
            throw errore;
          });
        }
        if (!r.body || !r.body.getReader) return r.text().then(function () { throw new Error('flusso non disponibile'); });
        return leggiFlusso(r, function (parziale) {
          b.classList.remove('chat__bolla--penso');
          formatta(el, parziale);
          scorri();
        });
      }).then(function (esito) {
        b.classList.remove('chat__bolla--penso');
        if (!esito.testo.trim()) throw new Error('vuoto');
        formatta(el, esito.testo);
        schede(b, esito.prodotti);
        storia.push({ ruolo: 'assistente', testo: esito.testo, prodotti: esito.prodotti });
        salva();
      }).catch(function (e) {
        b.classList.remove('chat__bolla--penso');
        b.classList.add('chat__bolla--errore');
        var occupatoServer = e && (e.stato === 429 || e.stato === 503);
        el.textContent = occupatoServer ? t.occupato : t.errore;
        if (!occupatoServer) contattoAlternativo(el);
        /* La domanda senza risposta non resta nella storia: alla prossima si riparte pulita. */
        if (storia.length && storia[storia.length - 1].ruolo === 'utente') storia.pop();
        salva();
      }).then(function () {
        clearTimeout(attesa);
        occupato = false;
        invio.disabled = false;
        aggiornaRicomincia();
        scorri();
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); invia(campo.value); });
    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); invia(campo.value); }
    });
    campo.addEventListener('input', function () {
      campo.style.height = '';
      campo.style.height = Math.min(campo.scrollHeight, 112) + 'px';
    });
    chat.addEventListener('click', function (e) {
      var spunto = e.target.closest('[data-chat-spunto]');
      if (spunto) invia(spunto.textContent);
    });
    mostraStoria();
  }

  /* ---------- il consiglio guidato ---------- */

  /* Senza un assistente vero, il pannello ne simula uno: poche domande a bottoni, i tre puntini
     fra un messaggio e l'altro, e alla fine la collezione nascosta del consiglio con tre prodotti
     in anteprima. Le domande stanno nella sezione (JSON «albero»). Le risposte date restano per la
     visita (sessionStorage): riaprendo il pannello, anche da un'altra pagina, si riparte da li'. */
  function guida(radice) {
    var box = (radice || document).querySelector('[data-guida]');
    if (!box || box.dataset.pronto) return;
    var albero;
    try { albero = JSON.parse(box.querySelector('[data-guida-albero]').textContent); } catch (e) { return; }
    box.dataset.pronto = '1';
    var t = tema.testi.chat || {};
    var tg = tema.testi.guida || {};
    var lista = box.querySelector('[data-guida-messaggi]');
    var risposte = box.querySelector('[data-guida-risposte]');
    var cenni = tg.cenni || [];
    var percorso = [];
    var daRifare = [];
    var turno = 0;
    var avviata = false;
    try { daRifare = JSON.parse(sessionStorage.getItem('aurea-guida') || '[]'); } catch (e) { daRifare = []; }
    if (!Array.isArray(daRifare)) daRifare = [];

    function salva() {
      try { sessionStorage.setItem('aurea-guida', JSON.stringify(percorso)); } catch (e) { /* senza memoria, vale per la pagina */ }
    }

    function scorri() { lista.scrollTop = lista.scrollHeight; }

    function prezzo(valore) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency: box.dataset.valuta || 'EUR' }).format(Number(valore));
      } catch (e) { return valore; }
    }

    function bolla(ruolo, testo) {
      var b = document.createElement('div');
      b.className = 'chat__bolla chat__bolla--' + ruolo;
      var chi = document.createElement('span');
      chi.className = 'chat__chi';
      chi.textContent = ruolo === 'utente' ? t.tu : albero.nome;
      var corpo = document.createElement('div');
      corpo.className = 'chat__testo';
      corpo.textContent = testo || '';
      b.appendChild(chi);
      b.appendChild(corpo);
      lista.appendChild(b);
      scorri();
      return b;
    }

    /* L'assistente «scrive»: prima i puntini, poi il messaggio. Subito quando si ricostruisce
       la conversazione, o per chi ha chiesto meno movimento. */
    function parla(testo, subito, poi) {
      if (subito || movimentoRidotto) { poi(bolla('assistente', testo)); return; }
      var mio = turno;
      var b = bolla('assistente');
      var corpo = b.querySelector('.chat__testo');
      corpo.innerHTML = '<span class="chat__puntini" aria-hidden="true"><i></i><i></i><i></i></span>';
      setTimeout(function () {
        if (mio !== turno) return;
        corpo.textContent = testo;
        scorri();
        poi(b);
      }, Math.min(1500, 550 + testo.length * 12));
    }

    function opzione(etichetta, azione) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'chat__spunto';
      b.textContent = etichetta;
      b.addEventListener('click', azione);
      risposte.appendChild(b);
      return b;
    }

    function domanda(chiave, subito, cenno, fuoco) {
      var d = albero.domande[chiave];
      if (!d) return;
      parla((cenno ? cenno + ' ' : '') + d.d, subito, function () {
        risposte.textContent = '';
        d.r.forEach(function (r, i) {
          opzione(r[0], function () { rispondi(chiave, i, false, true); });
        });
        if (daRifare.length) { rispondi(chiave, daRifare.shift(), true); return; }
        if (fuoco && risposte.firstChild) risposte.firstChild.focus({ preventScroll: true });
        scorri();
      });
    }

    function rispondi(chiave, i, subito, fuoco) {
      var r = albero.domande[chiave] && albero.domande[chiave].r[i];
      if (!r) { daRifare = []; return; }
      risposte.textContent = '';
      percorso.push(i);
      salva();
      bolla('utente', r[0]);
      if (r[1].indexOf('lista:') === 0) risultato(r[1].slice(6), subito, fuoco);
      else domanda(r[1], subito, subito ? '' : cenni[Math.floor(Math.random() * cenni.length)], fuoco);
    }

    function risultato(maniglia, subito, fuoco) {
      var url = box.dataset.collezioni.replace(/\/$/, '') + '/' + maniglia;
      parla(albero.liste[maniglia] || '', subito, function (b) {
        var mio = turno;
        fetch(url + '/products.json?limit=12', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (dati) { if (mio === turno) schede(b, (dati && dati.products) || []); })
          .catch(function () { /* resta il collegamento alla selezione */ });
        risposte.textContent = '';
        var vai = document.createElement('a');
        vai.className = 'chat__spunto guida__vai';
        vai.href = url;
        vai.textContent = tg.vedi;
        risposte.appendChild(vai);
        opzione(tg.ricomincia, ricomincia);
        if (fuoco) vai.focus({ preventScroll: true });
        scorri();
      });
    }

    function schede(b, prodotti) {
      if (!prodotti.length) return;
      var griglia = document.createElement('div');
      griglia.className = 'chat__schede';
      prodotti.slice(0, 3).forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'chat__scheda';
        a.href = box.dataset.prodotti.replace(/\/$/, '') + '/' + p.handle;
        var img = document.createElement('img');
        var foto = p.images && p.images[0] && p.images[0].src;
        if (foto) img.src = foto + (foto.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        img.alt = '';
        img.loading = 'lazy';
        img.width = 48; img.height = 48;
        img.onerror = function () { this.style.visibility = 'hidden'; };
        var testo = document.createElement('span');
        var titolo = document.createElement('span');
        titolo.className = 'chat__scheda-titolo';
        titolo.textContent = p.title;
        var costo = document.createElement('span');
        costo.className = 'chat__scheda-prezzo';
        var varianti = p.variants || [];
        var disponibile = varianti.some(function (v) { return v.available !== false; });
        var minimo = varianti.reduce(function (m, v) { return Math.min(m, Number(v.price)); }, Infinity);
        costo.textContent = !disponibile ? t.esaurito : (isFinite(minimo) ? prezzo(minimo) : '');
        testo.appendChild(titolo);
        testo.appendChild(costo);
        var vedi = document.createElement('span');
        vedi.className = 'chat__scheda-vedi';
        vedi.textContent = t.vedi;
        a.appendChild(img);
        a.appendChild(testo);
        a.appendChild(vedi);
        griglia.appendChild(a);
      });
      b.appendChild(griglia);
      if (prodotti.length > 3) {
        var altri = document.createElement('p');
        altri.className = 'guida__altri';
        altri.textContent = (tg.altri || '').replace('[n]', prodotti.length - 3);
        b.appendChild(altri);
      }
      scorri();
    }

    function inizia(subito, cenno) {
      turno++;
      lista.textContent = '';
      risposte.textContent = '';
      percorso = [];
      if (cenno) { domanda(albero.inizio, false, cenno, true); return; }
      parla(albero.saluto, subito, function () { domanda(albero.inizio, subito); });
    }

    function ricomincia() {
      daRifare = [];
      inizia(false, tg.daCapo);
      salva();
    }

    /* La conversazione comincia la prima volta che il pannello si apre: e' li' che si vede scrivere. */
    box.apri = function () {
      if (avviata) return;
      avviata = true;
      inizia(daRifare.length > 0);
    };
    if (box.closest('.concierge__pannello') && !box.closest('.concierge__pannello').hidden) box.apri();
  }

  /* ---------- passaggio tra le pagine ---------- */

  /* Un clic su un collegamento interno dissolve la pagina prima di cambiarla: il passaggio
     da una stanza all'altra, senza strappi. Solo clic semplici, senza tasti premuti. */
  /* Dove il browser sa fare le transizioni tra pagine (Chrome, Edge, Safari recenti) lascia fare a lui:
     la testata resta ferma e la foto del prodotto scelto vola dalla scheda alla sua pagina. */

  /* Il cambio pagina a fascia: uscendo la fascia del cofanetto entra e copre la pagina, poi si naviga; la
     pagina nuova la trova gia' chiusa (script nel <head>) e la sfila. Vedi «cambio pagina a fascia» in base.css. */
  /* La linea verso cui porta un collegamento: dalla collezione «linea-…», oppure dal nome di linea
     (classe .linea--…) nella scheda da cui parte il clic. */
  function lineaDi(link, dove) {
    var m = dove.pathname.match(/\/collections\/linea-([a-z]+)/);
    if (m) return m[1];
    var el = link.matches('[class*="linea--"]') ? link : null;
    if (!el) {
      var scheda = link.closest('article, li, .trova__risultato');
      el = scheda && scheda.querySelector('[class*="linea--"]');
    }
    var k = el && el.className.match(/linea--([a-z]+)/);
    return k ? k[1] : '';
  }

  function passaggi() {
    var radice = document.documentElement;
    var fascia = document.querySelector('.fascia-passaggio');

    // all'arrivo: sfilata la fascia, via le classi (le trasformazioni non devono restare sulla pagina)
    if (radice.classList.contains('fascia-arriva')) {
      var finisci = function () {
        radice.classList.remove('fascia-arriva');
        delete radice.dataset.fascia;
      };
      if (fascia) fascia.addEventListener('animationend', function (e) { if (e.animationName === 'fascia-esce') finisci(); });
      setTimeout(finisci, 1800);
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        radice.classList.remove('fascia-parte', 'fascia-arriva');
        delete radice.dataset.fascia;
      }
    });

    if (!movimento || inEditor || !fascia) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download') || link.dataset.apriCarrello !== undefined) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript|sms):/.test(href)) return;
      var dove;
      try { dove = new URL(link.href, window.location.href); } catch (err) { return; }
      if (dove.origin !== window.location.origin || /^\/(checkout|cart\/|account\/logout)/.test(dove.pathname)) return;
      if (dove.pathname === window.location.pathname && dove.search === window.location.search) return;
      e.preventDefault();
      var linea = lineaDi(link, dove);
      if (linea) radice.dataset.fascia = linea; else delete radice.dataset.fascia;
      try { sessionStorage.setItem('aurea-fascia', linea || '1'); } catch (err) {}
      radice.classList.remove('fascia-arriva');
      radice.classList.add('fascia-parte');
      setTimeout(function () { window.location.href = dove.href; }, 560);
    });
  }

  /* ---------- carrello ---------- */

  function sezioniCarrello() {
    var sezioni = [];
    if (document.querySelector('[data-pannello-carrello]')) sezioni.push('cart-drawer');
    var pagina = document.querySelector('[data-pagina-carrello]');
    if (pagina) sezioni.push(pagina.dataset.sezione);
    return sezioni;
  }

  function aggiornaConteggio(quanti, salta) {
    tutti('[data-conteggio-carrello]').forEach(function (c) {
      c.textContent = quanti;
      c.hidden = quanti === 0;
      if (salta && quanti > 0) {
        c.classList.remove('salta');
        void c.offsetWidth;
        c.classList.add('salta');
      }
    });
  }

  /* Il pulsante dice «Aggiunto» per un momento, poi torna com'era. */
  function confermaSulPulsante(pulsante) {
    if (!pulsante || pulsante.dataset.confermando) return;
    /* Nella scheda prodotto il testo sta in uno span accanto all'icona, che resta. */
    var bersaglio = pulsante.querySelector('span') || pulsante;
    var prima = bersaglio.textContent;
    pulsante.dataset.confermando = '1';
    pulsante.classList.add('confermato');
    bersaglio.textContent = tema.testi.aggiunto;
    setTimeout(function () {
      bersaglio.textContent = prima;
      pulsante.classList.remove('confermato');
      delete pulsante.dataset.confermando;
    }, 1800);
  }

  function sostituisciSezioni(sezioni) {
    if (!sezioni) return;
    if (sezioni['cart-drawer']) {
      var vecchio = document.querySelector('[data-pannello-carrello]');
      var nuovo = html(sezioni['cart-drawer']).querySelector('[data-pannello-carrello]');
      if (vecchio && nuovo) {
        nuovo.hidden = vecchio.hidden;
        vecchio.replaceWith(nuovo);
        consegna(nuovo);
      }
    }
    var pagina = document.querySelector('[data-pagina-carrello]');
    if (pagina && sezioni[pagina.dataset.sezione]) {
      var nuova = html(sezioni[pagina.dataset.sezione]).querySelector('[data-pagina-carrello]');
      if (nuova) { pagina.replaceWith(nuova); consegna(nuova); }
    }
  }

  /* Il prodotto vola nella borsa della testata: una copia della foto parte da dove sta, sale
     in un arco e rimpicciolisce fino all'icona, che lo accoglie con un sobbalzo. */
  function volaNelCarrello(modulo) {
    if (!movimento) return;
    var borsa = tutti('.testata__carrello').filter(function (b) { return b.offsetParent; })[0];
    var scheda = modulo.closest('.scheda-prodotto');
    var sorgente = scheda ? scheda.querySelector('.scheda-prodotto__immagine') : document.querySelector('.galleria__elemento.attivo img, .galleria__elemento img');
    if (!borsa || !sorgente || !sorgente.animate) return;
    var da = sorgente.getBoundingClientRect(), a = borsa.getBoundingClientRect();
    if (!da.width) return;
    var lato = Math.min(da.width, da.height, 320);
    var copia = document.createElement('div');
    copia.className = 'volo';
    var foto = sorgente.tagName === 'IMG' ? 'url("' + (sorgente.currentSrc || sorgente.src) + '")' : getComputedStyle(sorgente).backgroundImage;
    copia.style.backgroundImage = foto;
    copia.style.width = copia.style.height = lato + 'px';
    copia.style.left = (da.left + da.width / 2 - lato / 2) + 'px';
    copia.style.top = (da.top + da.height / 2 - lato / 2) + 'px';
    document.body.appendChild(copia);
    var dx = a.left + a.width / 2 - (da.left + da.width / 2), dy = a.top + a.height / 2 - (da.top + da.height / 2);
    var fine = 28 / lato;
    copia.animate([
      { transform: 'translate(0, 0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.35 + 'px, ' + (dy * 0.35 - 140) + 'px) scale(0.62) rotate(-8deg)', opacity: 1, offset: 0.4 },
      { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + fine + ') rotate(4deg)', opacity: 0.9 }
    ], { duration: 820, easing: 'cubic-bezier(0.5, 0, 0.3, 1)', fill: 'forwards' }).onfinish = function () {
      copia.remove();
      borsa.classList.remove('accoglie');
      void borsa.offsetWidth;
      borsa.classList.add('accoglie');
    };
  }

  function aggiungi(modulo) {
    var pulsante = modulo.querySelector('[type="submit"]');
    var errore = modulo.querySelector('[data-errore-carrello]');
    var dati = new FormData(modulo);
    var sezioni = sezioniCarrello();
    if (sezioni.length) {
      dati.append('sections', sezioni.join(','));
      dati.append('sections_url', window.location.pathname);
    }
    if (pulsante) { pulsante.disabled = true; pulsante.setAttribute('aria-busy', 'true'); }
    if (errore) errore.hidden = true;

    fetch(rotte.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: dati
    })
      .then(function (r) { return r.json().then(function (corpo) { return { ok: r.ok, corpo: corpo }; }); })
      .then(function (esito) {
        if (!esito.ok) {
          var messaggio = esito.corpo.description || esito.corpo.message || tema.testi.errore;
          if (errore) { errore.textContent = messaggio; errore.hidden = false; } else { avvisa(messaggio); }
          return;
        }
        volaNelCarrello(modulo);
        if (tema.tipoCarrello !== 'drawer' || !document.querySelector('[data-pannello-carrello]')) {
          setTimeout(function () { window.location = rotte.cart_url; }, movimento ? 700 : 0);
          return;
        }
        sostituisciSezioni(esito.corpo.sections);
        return fetch(rotte.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (carrello) {
            aggiornaConteggio(carrello.item_count, true);
            var pannello = document.querySelector('[data-pannello-carrello]');
            /*
             * Il pannello non si apre da solo: chi compra decide quando
             * guardare il carrello. Resta il contatore che salta, il
             * pulsante che conferma e un avviso con la strada per arrivarci.
             */
            if (tema.apriCarrelloDopoAggiunta) { apriPannello(pannello); return; }
            confermaSulPulsante(pulsante);
            avvisa(tema.testi.aggiunto, { testo: tema.testi.vediCarrello, esegui: function () { apriPannello(pannello); } });
          });
      })
      .catch(function () { avvisa(tema.testi.errore); })
      .finally(function () {
        if (pulsante) { pulsante.disabled = false; pulsante.removeAttribute('aria-busy'); }
      });
  }

  function cambiaRiga(indice, quantita) {
    var riga = document.querySelector('[data-riga="' + indice + '"]');
    tutti('[data-riga="' + indice + '"]').forEach(function (r) { r.classList.add('in-aggiornamento'); });
    fetch(rotte.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(indice), quantity: quantita, sections: sezioniCarrello(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (corpo) { return { ok: r.ok, corpo: corpo }; }); })
      .then(function (esito) {
        if (!esito.ok) {
          avvisa(esito.corpo.description || esito.corpo.message || tema.testi.errore);
          if (riga) riga.classList.remove('in-aggiornamento');
          return;
        }
        sostituisciSezioni(esito.corpo.sections);
        aggiornaConteggio(esito.corpo.item_count);
      })
      .catch(function () {
        tutti('[data-riga="' + indice + '"]').forEach(function (r) { r.classList.remove('in-aggiornamento'); });
        avvisa(tema.testi.errore);
      });
  }

  var attesaRiga = {};
  function programmaRiga(campo) {
    var indice = campo.dataset.indice;
    clearTimeout(attesaRiga[indice]);
    attesaRiga[indice] = setTimeout(function () {
      cambiaRiga(indice, Math.max(0, parseInt(campo.value, 10) || 0));
    }, 450);
  }

  /* ---------- varianti e galleria ---------- */

  function mostraMedia(galleria, id) {
    if (!galleria || !id) return;
    var bersaglio = galleria.querySelector('[data-media-id="' + id + '"]');
    if (!bersaglio) return;
    tutti('[data-media-id]', galleria).forEach(function (m) {
      var attivo = m === bersaglio;
      m.hidden = !attivo;
      m.classList.toggle('attivo', attivo);
    });
    tutti('[data-mostra-media]', galleria).forEach(function (b) {
      var attivo = b.dataset.mostraMedia === String(id);
      b.classList.toggle('attiva', attivo);
      if (attivo) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
    });
  }

  function cambiaVariante(contenitore) {
    var prodotto = contenitore.closest('[data-prodotto]');
    var elenco = contenitore.querySelector('[data-elenco-varianti]');
    if (!prodotto || !elenco) return;
    var varianti = JSON.parse(elenco.textContent);
    var scelte = [];
    tutti('input[type="radio"]:checked', contenitore).forEach(function (i) {
      scelte[Number(i.dataset.indiceOpzione)] = i.value;
    });
    tutti('[data-valore-scelto]', contenitore).forEach(function (s) {
      s.textContent = scelte[Number(s.dataset.valoreScelto)] || '';
    });

    var variante = varianti.find(function (v) {
      return v.options.every(function (valore, i) { return valore === scelte[i]; });
    });

    /* Le combinazioni che non esistono o sono esaurite, dato quello che è già scelto. */
    tutti('input[type="radio"]', contenitore).forEach(function (campo) {
      var indice = Number(campo.dataset.indiceOpzione);
      var possibili = varianti.filter(function (v) {
        return v.options[indice] === campo.value && v.options.every(function (valore, i) {
          return i === indice || valore === scelte[i];
        });
      });
      var etichetta = campo.nextElementSibling;
      if (etichetta) etichetta.classList.toggle('non-disponibile', !possibili.some(function (v) { return v.available; }));
    });

    var pulsante = prodotto.querySelector('[name="add"]');
    if (!variante) {
      if (pulsante) { pulsante.disabled = true; pulsante.textContent = tema.testi.nonDisponibile; }
      return;
    }

    tutti('[data-id-variante]', prodotto).forEach(function (i) { i.value = variante.id; });
    if (variante.featured_media) mostraMedia(prodotto.querySelector('[data-galleria]'), variante.featured_media.id);

    var indirizzo = new URL(window.location.href);
    indirizzo.searchParams.set('variant', variante.id);
    window.history.replaceState({}, '', indirizzo.toString());

    fetch(prodotto.dataset.url + '?variant=' + variante.id + '&section_id=' + prodotto.dataset.sezione)
      .then(function (r) { return r.text(); })
      .then(function (testo) {
        var nuovo = html(testo);
        tutti('[data-aggiorna]', prodotto).forEach(function (vecchio) {
          var sostituto = nuovo.getElementById(vecchio.id);
          if (sostituto) vecchio.replaceWith(sostituto);
        });
      });
  }

  /* ---------- prodotti correlati ---------- */

  function correlati(radice) {
    tutti('[data-correlati]', radice).forEach(function (sezione) {
      if (sezione.dataset.caricato || !sezione.dataset.url) return;
      sezione.dataset.caricato = '1';
      fetch(sezione.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (testo) {
          var nuova = html(testo).querySelector('[data-correlati]');
          if (nuova && nuova.innerHTML.trim()) {
            sezione.innerHTML = nuova.innerHTML;
            rivela(sezione);
          }
        });
    });
  }

  /* ---------- indirizzi ---------- */

  function province(radice) {
    tutti('[data-paese]', radice).forEach(function (paese) {
      var modulo = paese.closest('form');
      var provincia = modulo && modulo.querySelector('[data-provincia]');
      var contenitore = modulo && modulo.querySelector('[data-contenitore-provincia]');
      if (paese.dataset.default) paese.value = paese.dataset.default;

      function aggiorna() {
        var opzione = paese.options[paese.selectedIndex];
        var elenco = opzione ? JSON.parse(opzione.dataset.provinces || '[]') : [];
        if (!provincia) return;
        provincia.innerHTML = '';
        elenco.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          provincia.appendChild(o);
        });
        if (provincia.dataset.default) provincia.value = provincia.dataset.default;
        if (contenitore) contenitore.hidden = elenco.length === 0;
      }
      paese.addEventListener('change', function () { provincia.dataset.default = ''; aggiorna(); });
      aggiorna();
    });
  }

  /* ---------- movimento: titoli, parallasse, contatori ---------- */

  var movimento = tema.animazioni !== false && !movimentoRidotto;
  var puntatoreFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function limita(valore, minimo, massimo) { return Math.min(massimo, Math.max(minimo, valore)); }

  /* Divide un titolo in parole, ognuna nella propria maschera, rispettando i corsivi.
     Le parole salgono una dopo l'altra appena il titolo entra nello schermo: in tutto
     meno di un secondo, cosi' nessuno aspetta per leggere. */
  function dividiNodo(nodo, contatore) {
    Array.prototype.slice.call(nodo.childNodes).forEach(function (figlio) {
      if (figlio.nodeType === 3) {
        var frammento = document.createDocumentFragment();
        figlio.textContent.split(/(\s+)/).forEach(function (pezzo) {
          if (!pezzo) return;
          if (/^\s+$/.test(pezzo)) { frammento.appendChild(document.createTextNode(' ')); return; }
          var parola = document.createElement('span');
          parola.className = 'parola';
          var interno = document.createElement('span');
          interno.textContent = pezzo;
          interno.style.setProperty('--n', contatore.n++);
          parola.appendChild(interno);
          frammento.appendChild(parola);
        });
        figlio.replaceWith(frammento);
      } else if (figlio.nodeType === 1 && figlio.tagName !== 'BR') {
        dividiNodo(figlio, contatore);
      }
    });
  }

  function dividi(radice) {
    if (!movimento || inEditor) return;
    tutti('[data-dividi]:not(.diviso)', radice).forEach(function (titolo) {
      titolo.setAttribute('aria-label', titolo.textContent.replace(/\s+/g, ' ').trim());
      dividiNodo(titolo, { n: 0 });
      titolo.classList.add('diviso');
      if (!('IntersectionObserver' in window)) { titolo.classList.add('visibile'); return; }
      var osservatore = new IntersectionObserver(function (voci) {
        voci.forEach(function (voce) {
          if (!voce.isIntersecting) return;
          voce.target.classList.add('visibile');
          osservatore.unobserve(voce.target);
        });
      }, { threshold: 0.2 });
      osservatore.observe(titolo);
    });
  }

  /* Le dichiarazioni (data-righe) salgono riga per riga: si dividono in parole come i titoli,
     poi le parole sulla stessa riga prendono lo stesso ritardo. */
  function righe(radice) {
    if (!movimento || inEditor) return;
    tutti('[data-righe]:not(.righe)', radice).forEach(function (testo) {
      testo.setAttribute('aria-label', testo.textContent.replace(/\s+/g, ' ').trim());
      dividiNodo(testo, { n: 0 });
      testo.classList.add('righe');
      var parole = tutti('.parola', testo);
      var riga = -1, ultimaCima = null;
      var cime = parole.map(function (p) { return p.offsetTop; });
      parole.forEach(function (p, i) {
        if (ultimaCima === null || Math.abs(cime[i] - ultimaCima) > 4) { riga++; ultimaCima = cime[i]; }
        p.firstChild.style.setProperty('--riga', riga);
      });
      if (!('IntersectionObserver' in window)) { testo.classList.add('visibile'); return; }
      var osservatore = new IntersectionObserver(function (voci) {
        voci.forEach(function (voce) {
          if (!voce.isIntersecting) return;
          voce.target.classList.add('visibile');
          osservatore.unobserve(voce.target);
        });
      }, { threshold: 0.25 });
      osservatore.observe(testo);
    });
  }

  /* La vetrina della copertina: il nome che arriva al centro dello schermo (o su cui passa il puntatore,
     o che riceve il fuoco) mette il suo prodotto sulla teca e il suo colore sul campo. */
  function vetrine(radice) {
    tutti('[data-vetrina]', radice).forEach(function (vetrina) {
      if (vetrina.dataset.pronta) return;
      vetrina.dataset.pronta = '1';
      var voci = tutti('[data-vetrina-voce]', vetrina);
      var oggetti = tutti('[data-vetrina-oggetto]', vetrina);
      var campo = vetrina.querySelector('[data-vetrina-campo]');
      var didascalia = vetrina.querySelector('[data-vetrina-didascalia]');
      if (!voci.length) return;
      var attuale = -1;
      function attiva(indice) {
        if (indice === attuale || indice < 0 || indice >= voci.length) return;
        attuale = indice;
        voci.forEach(function (v, k) { v.classList.toggle('attiva', k === indice); });
        oggetti.forEach(function (o, k) { o.classList.toggle('attivo', k === indice); });
        if (campo) vetrina.style.setProperty('--campo-attivo', voci[indice].dataset.campo);
        if (didascalia) didascalia.textContent = voci[indice].dataset.nome;
      }
      attiva(0);
      voci.forEach(function (voce, k) {
        voce.addEventListener('pointerenter', function () { attiva(k); });
        voce.addEventListener('focusin', function () { attiva(k); });
      });
      if (!('IntersectionObserver' in window)) return;
      var osservatore = new IntersectionObserver(function (elementi) {
        elementi.forEach(function (el) {
          if (el.isIntersecting) attiva(voci.indexOf(el.target));
        });
      }, { rootMargin: '-42% 0px -42% 0px' });
      voci.forEach(function (v) { osservatore.observe(v); });
      /* Tornando in cima, la vetrina riparte dal primo prodotto. */
      var apertura = vetrina.querySelector('.vetrina__apertura');
      if (apertura) {
        new IntersectionObserver(function (el) { if (el[0].isIntersecting && el[0].intersectionRatio > 0.6) attiva(0); }, { threshold: [0.6] }).observe(apertura);
      }
    });
  }

  /* Parallasse leggera: gli elementi con data-parallasse scorrono un po' piu' piano della pagina. */
  function scorriParallasse() {
    if (!movimento) return;
    var alto = window.innerHeight;
    tutti('[data-parallasse]').forEach(function (e) {
      var riferimento = (e.parentElement || e).getBoundingClientRect();
      if (riferimento.bottom < -200 || riferimento.top > alto + 200) return;
      var velocita = parseFloat(e.dataset.parallasse) || 0.1;
      var scarto = (riferimento.top + riferimento.height / 2 - alto / 2) * -velocita;
      e.style.setProperty('--spostamento', scarto.toFixed(1) + 'px');
    });
  }

  /* I numeri contano fino al loro valore quando entrano nello schermo. */
  function contatori(radice) {
    var elementi = tutti('[data-conta]:not([data-contato])', radice);
    if (!elementi.length) return;
    var lingua = document.documentElement.lang || 'it';
    function formatta(valore, decimali) {
      return valore.toLocaleString(lingua, { minimumFractionDigits: decimali, maximumFractionDigits: decimali });
    }
    elementi.forEach(function (e) {
      e.setAttribute('data-contato', '');
      var testo = String(e.dataset.conta).trim().replace(/\s/g, '');
      var normale = /^\d{1,3}([.,]\d{3})+$/.test(testo) ? testo.replace(/[.,]/g, '') : testo.replace(',', '.');
      var finale = parseFloat(normale);
      if (isNaN(finale) || !/^[\d.]+$/.test(normale) || !movimento || inEditor || !('IntersectionObserver' in window)) return;
      var decimali = (normale.split('.')[1] || '').length;
      e.textContent = formatta(0, decimali);
      var osservatore = new IntersectionObserver(function (voci) {
        if (!voci[0].isIntersecting) return;
        osservatore.disconnect();
        var inizio = performance.now();
        (function passo(ora) {
          var t = limita((ora - inizio) / 1600, 0, 1);
          var curva = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
          e.textContent = formatta(finale * curva, decimali);
          if (t < 1) requestAnimationFrame(passo); else e.textContent = formatta(finale, decimali);
        })(inizio);
      }, { threshold: 0.6 });
      osservatore.observe(e);
    });
  }

  /* La composizione in copertina si inclina appena verso il puntatore. */
  function inclina() {
    if (!puntatoreFine || !movimento) return;
    tutti('[data-inclina]').forEach(function (sezione) {
      var bersaglio = sezione.querySelector('.composizione, .copertina__zoom');
      if (!bersaglio) return;
      sezione.addEventListener('pointermove', function (e) {
        var r = sezione.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        bersaglio.style.setProperty('--tx', (x * -18).toFixed(1) + 'px');
        bersaglio.style.setProperty('--ty', (y * -12).toFixed(1) + 'px');
      }, { passive: true });
      sezione.addEventListener('pointerleave', function () {
        bersaglio.style.setProperty('--tx', '0px');
        bersaglio.style.setProperty('--ty', '0px');
      });
    });
  }

  /* Le foto dei prodotti e le copertine delle collezioni si comportano come oggetti: sotto il
     puntatore si inclinano appena e un riflesso di luce scorre sulla superficie. */
  function oggetti(radice) {
    if (!puntatoreFine || !movimento) return;
    tutti('.scheda-prodotto__media:not([data-oggetto]), .copertina-collezione:not([data-oggetto])', radice).forEach(function (el) {
      el.setAttribute('data-oggetto', '');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--ry', ((x - 0.5) * 9).toFixed(2) + 'deg');
        el.style.setProperty('--rx', ((0.5 - y) * 7).toFixed(2) + 'deg');
        el.style.setProperty('--lx', (x * 100).toFixed(1) + '%');
        el.style.setProperty('--ly', (y * 100).toFixed(1) + '%');
      }, { passive: true });
      el.addEventListener('pointerleave', function () {
        el.style.removeProperty('--rx'); el.style.removeProperty('--ry');
      });
    });
  }

  /* ---------- scorrimento: testata, linea di lettura e barra d'acquisto ---------- */

  function scorriLinea() {
    var linea = document.querySelector('.linea-lettura');
    if (!linea) return;
    var massimo = document.documentElement.scrollHeight - window.innerHeight;
    linea.style.setProperty('--letto-frazione', (massimo > 0 ? limita(window.scrollY / massimo, 0, 1) : 0).toFixed(4));
  }

  /* Testata: trasparente in cima, si nasconde scendendo e ricompare risalendo. */
  var ultimoScorrimento = window.scrollY;
  function scorriTestata() {
    var testata = document.querySelector('[data-testata]');
    if (!testata) return;
    var y = window.scrollY;
    testata.classList.toggle('testata--scorsa', y > 40);
    var aperta = testata.querySelector('.menu__voce--tendina:hover, details[open]');
    if (testata.dataset.nascondi === 'true' && !aperta) {
      if (y > 480 && y - ultimoScorrimento > 6) testata.classList.add('testata--nascosta');
      if (ultimoScorrimento - y > 6 || y < 480) testata.classList.remove('testata--nascosta');
    }
    ultimoScorrimento = y;
  }

  function scorriBarraAcquisto() {
    var barra = document.querySelector('[data-barra-acquisto]');
    var modulo = document.getElementById('ModuloProdotto');
    if (!barra || !modulo) return;
    var visibile = modulo.getBoundingClientRect().bottom < 0;
    if (barra.classList.contains('visibile') === visibile) return;
    barra.classList.toggle('visibile', visibile);
    barra.setAttribute('aria-hidden', String(!visibile));
    tutti('button, a', barra).forEach(function (b) { b.tabIndex = visibile ? 0 : -1; });
  }

  var scorrimentoProgrammato = false;
  function alloScorrimento() {
    if (scorrimentoProgrammato) return;
    scorrimentoProgrammato = true;
    requestAnimationFrame(function () {
      scorrimentoProgrammato = false;
      scorriTestata();
      scorriLinea();
      scorriParallasse();
      scorriBarraAcquisto();
    });
  }
  window.addEventListener('scroll', alloScorrimento, { passive: true });
  window.addEventListener('resize', alloScorrimento);

  /* ---------- sezioni interattive ---------- */

  function caroselli(radice) {
    tutti('[data-carosello]', radice).forEach(function (sezione) {
      var binario = sezione.querySelector('[data-carosello-binario]');
      if (!binario || binario.dataset.avviato) return;
      binario.dataset.avviato = '1';
      var barra = sezione.querySelector('[data-carosello-avanzamento]');
      var indietro = sezione.querySelector('[data-carosello-indietro]');
      var avanti = sezione.querySelector('[data-carosello-avanti]');

      function aggiorna() {
        var massimo = binario.scrollWidth - binario.clientWidth;
        if (barra) {
          var quota = binario.scrollWidth ? (binario.scrollLeft + binario.clientWidth) / binario.scrollWidth : 1;
          barra.style.setProperty('--avanzamento', (limita(quota, 0, 1) * 100).toFixed(1) + '%');
        }
        if (indietro) indietro.disabled = binario.scrollLeft <= 2;
        if (avanti) avanti.disabled = binario.scrollLeft >= massimo - 2;
      }
      function sposta(verso) {
        var elemento = binario.querySelector('.carosello__elemento');
        var passo = elemento ? elemento.getBoundingClientRect().width + 24 : binario.clientWidth * 0.8;
        binario.scrollBy({ left: verso * passo * Math.max(1, Math.floor(binario.clientWidth / passo) - 1), behavior: movimentoRidotto ? 'auto' : 'smooth' });
      }
      if (indietro) indietro.addEventListener('click', function () { sposta(-1); });
      if (avanti) avanti.addEventListener('click', function () { sposta(1); });
      binario.addEventListener('scroll', aggiorna, { passive: true });
      window.addEventListener('resize', aggiorna);
      aggiorna();

      /* Trascinamento col mouse; dita e trackpad scorrono già da soli. */
      var inizioX = 0, inizioScorrimento = 0, premuto = false;
      binario.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        premuto = true; inizioX = e.clientX; inizioScorrimento = binario.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!premuto) return;
        var dx = e.clientX - inizioX;
        if (Math.abs(dx) > 6) binario.classList.add('trascina');
        if (binario.classList.contains('trascina')) binario.scrollLeft = inizioScorrimento - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!premuto) return;
        premuto = false;
        setTimeout(function () { binario.classList.remove('trascina'); }, 0);
      });
      binario.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  function attivaPasso(sezione, indice) {
    tutti('[data-passo]', sezione).forEach(function (p) { p.classList.toggle('attivo', Number(p.dataset.passo) === indice); });
    tutti('[data-passo-immagine]', sezione).forEach(function (i) { i.classList.toggle('attiva', Number(i.dataset.passoImmagine) === indice); });
  }

  function rituali(radice) {
    tutti('[data-rituale]', radice).forEach(function (sezione) {
      if (sezione.dataset.avviato) return;
      sezione.dataset.avviato = '1';
      attivaPasso(sezione, 0);
      if (!('IntersectionObserver' in window)) return;
      var osservatore = new IntersectionObserver(function (voci) {
        voci.forEach(function (voce) {
          if (voce.isIntersecting) attivaPasso(sezione, Number(voce.target.dataset.passo));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      tutti('[data-passo]', sezione).forEach(function (p) { osservatore.observe(p); });
    });
  }

  function apriPunto(sezione, indice, alternando) {
    tutti('[data-punto]', sezione).forEach(function (p) {
      var questo = Number(p.dataset.punto) === indice;
      var aperto = questo && !(alternando && p.classList.contains('aperto'));
      p.classList.toggle('aperto', aperto);
      var pulsante = p.querySelector('.punto__pulsante');
      if (pulsante) pulsante.setAttribute('aria-expanded', String(aperto));
    });
    tutti('[data-punto-voce]', sezione).forEach(function (v) { v.classList.toggle('attiva', Number(v.dataset.puntoVoce) === indice); });
  }

  function punti(radice) {
    tutti('[data-punto]', radice).forEach(function (p) {
      var x = parseFloat(p.style.getPropertyValue('--x'));
      var y = parseFloat(p.style.getPropertyValue('--y'));
      p.classList.toggle('punto--destra', x > 62);
      p.classList.toggle('punto--sinistra', x < 38);
      p.classList.toggle('punto--sopra', y > 62);
    });
  }

  function vaiRecensione(sezione, indice) {
    var figure = tutti('[data-recensione]', sezione);
    if (!figure.length) return;
    indice = (indice + figure.length) % figure.length;
    figure.forEach(function (f, i) { f.classList.toggle('attiva', i === indice); });
    tutti('[data-vai-recensione]', sezione).forEach(function (p, i) {
      var attivo = i === indice;
      p.classList.remove('attivo');
      if (attivo) { void p.offsetWidth; p.classList.add('attivo'); }
      p.setAttribute('aria-selected', String(attivo));
    });
    sezione.dataset.attuale = indice;
  }

  function recensioni(radice) {
    tutti('[data-recensioni]', radice).forEach(function (sezione) {
      if (sezione.dataset.avviato) return;
      sezione.dataset.avviato = '1';
      sezione.dataset.attuale = 0;
      if (!movimento || inEditor) sezione.classList.add('ferme');
      sezione.addEventListener('animationend', function (e) {
        if (e.animationName !== 'riempi' || sezione.classList.contains('ferme')) return;
        vaiRecensione(sezione, Number(sezione.dataset.attuale) + 1);
      });
    });
  }

  /* ---------- eventi delegati ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;

    var apriConc = t.closest('[data-apri-concierge]');
    if (apriConc) {
      if (t.closest('[data-chiudi-carrello]')) chiudiPannelli();
      if (concierge() && concierge().classList.contains('aperto') && !apriConc.dataset.conciergeMessaggio) { chiudiConcierge(); return; }
      apriConcierge(apriConc.dataset.conciergeMessaggio || '');
      return;
    }
    if (t.closest('[data-chiudi-concierge]')) { chiudiConcierge(); return; }
    var conc = concierge();
    /* una risposta del consiglio sparisce dal pannello appena premuta: non conta come clic fuori */
    if (conc && conc.classList.contains('aperto') && !conc.contains(t) && document.contains(t)) chiudiConcierge();

    var apriMenu = t.closest('[data-apri-menu]');
    if (apriMenu) {
      apriMenu.setAttribute('aria-expanded', 'true');
      apriPannello(document.getElementById(apriMenu.getAttribute('aria-controls')));
      return;
    }
    if (t.closest('[data-chiudi-menu], [data-chiudi-carrello]')) { chiudiPannelli(); return; }

    var apriCarrello = t.closest('[data-apri-carrello]');
    if (apriCarrello && tema.tipoCarrello === 'drawer' && document.querySelector('[data-pannello-carrello]')) {
      e.preventDefault();
      apriPannello(document.querySelector('[data-pannello-carrello]'));
      return;
    }

    var meno = t.closest('[data-quantita-meno]');
    var piu = t.closest('[data-quantita-piu]');
    if (meno || piu) {
      var campo = (meno || piu).closest('[data-quantita]').querySelector('input');
      var minimo = Number(campo.min || 0);
      var valore = (parseInt(campo.value, 10) || 0) + (piu ? 1 : -1);
      campo.value = Math.max(minimo, valore);
      if (campo.dataset.indice) programmaRiga(campo);
      return;
    }

    var rimuovi = t.closest('[data-rimuovi]');
    if (rimuovi) {
      e.preventDefault();
      cambiaRiga(rimuovi.dataset.rimuovi, 0);
      return;
    }

    var voce = t.closest('[data-punto-voce]');
    if (voce) {
      apriPunto(voce.closest('[data-punti]'), Number(voce.dataset.puntoVoce), false);
      return;
    }
    var punto = t.closest('.punto__pulsante');
    if (punto) {
      apriPunto(punto.closest('[data-punti]'), Number(punto.closest('[data-punto]').dataset.punto), true);
      return;
    }

    var recensione = t.closest('[data-vai-recensione]');
    if (recensione) {
      vaiRecensione(recensione.closest('[data-recensioni]'), Number(recensione.dataset.vaiRecensione));
      return;
    }

    var miniatura = t.closest('[data-mostra-media]');
    if (miniatura) {
      mostraMedia(miniatura.closest('[data-galleria]'), miniatura.dataset.mostraMedia);
      return;
    }

    var filtri = t.closest('[data-apri-filtri]');
    if (filtri) {
      var pannello = document.getElementById(filtri.getAttribute('aria-controls'));
      var aperto = filtri.getAttribute('aria-expanded') === 'true';
      filtri.setAttribute('aria-expanded', String(!aperto));
      if (pannello) pannello.hidden = aperto;
      return;
    }

    /* Una tendina aperta si chiude cliccando altrove. */
    tutti('details[data-tendina][open]').forEach(function (d) {
      if (!d.contains(t)) d.removeAttribute('open');
    });
  });

  document.addEventListener('submit', function (e) {
    var modulo = e.target;
    if (modulo.matches('[data-aggiungi-al-carrello]')) {
      e.preventDefault();
      aggiungi(modulo);
      return;
    }
    if (modulo.dataset.conferma && !window.confirm(modulo.dataset.conferma)) {
      e.preventDefault();
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-indice]')) { programmaRiga(t); return; }
    if (t.matches('[data-varianti] input')) { cambiaVariante(t.closest('[data-varianti]')); return; }
    if (t.matches('[data-invia-al-cambio]')) { t.form.submit(); return; }
    if (t.matches('[data-pannello-filtri] input[type="checkbox"]')) { t.form.requestSubmit ? t.form.requestSubmit() : t.form.submit(); return; }
    if (t.matches('[data-nota-carrello]')) {
      fetch(rotte.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: t.value })
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    trattieniFuoco(e);
    if (e.key !== 'Escape') return;
    if (concierge() && concierge().classList.contains('aperto')) { chiudiConcierge(); return; }
    if (document.querySelector('[data-menu-mobile]:not([hidden]), [data-pannello-carrello]:not([hidden])')) {
      chiudiPannelli();
      return;
    }
    tutti('details[data-tendina][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  /* La tendina della ricerca porta il fuoco nel campo appena si apre. */
  document.addEventListener('toggle', function (e) {
    if (e.target.matches && e.target.matches('.cerca-testata') && e.target.open) {
      var campo = e.target.querySelector('input[type="search"]');
      if (campo) campo.focus();
    }
  }, true);

  document.addEventListener('pointerover', function (e) {
    if (!puntatoreFine || !e.target.closest) return;
    var voce = e.target.closest('[data-punto-voce]');
    if (voce && !voce.classList.contains('attiva')) apriPunto(voce.closest('[data-punti]'), Number(voce.dataset.puntoVoce), false);
  });

  /* ---------- la scena 3D ----------
     Il modulo (three.js compreso) si scarica solo se la pagina ha una scena, il dispositivo
     ha WebGL e il movimento non e' ridotto; altrimenti resta la copertina ferma. */
  function conWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }

  /* Lo script della scena (three.js compreso, ~130 KB compressi) si aggiunge solo quando serve. */
  function caricaModulo(indirizzo) {
    return new Promise(function (ok, ko) {
      if (window.AureaScena) return ok(window.AureaScena);
      var script = document.createElement('script');
      script.src = indirizzo;
      script.async = true;
      script.onload = function () { window.AureaScena ? ok(window.AureaScena) : ko(new Error('scena assente')); };
      script.onerror = function () { ko(new Error('scena non scaricata')); };
      document.head.appendChild(script);
    });
  }

  function scene(radice) {
    tutti('[data-scena]:not(.scena--viva)', radice).forEach(function (sezione) {
      if (movimentoRidotto || !sezione.dataset.modulo || !conWebGL()) return;
      sezione.classList.add('scena--viva');
      caricaModulo(sezione.dataset.modulo).then(function (m) { return m.avviaScena(sezione); }).catch(function (errore) {
        sezione.classList.remove('scena--viva', 'scena--pronta');
        document.documentElement.classList.remove('scena-in-vista', 'scena-al-buio');
        if (window.console) console.warn('Scena 3D non disponibile:', errore);
      });
    });
  }

  function avvia(radice) {
    dividi(radice);
    scene(radice);
    righe(radice);
    vetrine(radice);
    rivela(radice);
    oggetti(radice);
    annunci(radice);
    correlati(radice);
    province(radice);
    caroselli(radice);
    rituali(radice);
    punti(radice);
    contatori(radice);
    recensioni(radice);
    assistente(radice);
    guida(radice);
    consegna(radice);
    alloScorrimento();
  }

  /* La stima della consegna: oggi + 3–5 giorni lavorativi (sabato e domenica non contano), con le date. */
  function consegna(radice) {
    tutti('[data-consegna]', radice).forEach(function (el) {
      var testo = el.querySelector('[data-consegna-testo]');
      if (!testo || !tema.testi.consegna) return;
      function lavorativi(n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      }
      var formato = new Intl.DateTimeFormat(document.documentElement.lang || 'it', { weekday: 'short', day: 'numeric', month: 'long' });
      testo.textContent = tema.testi.consegna
        .replace('{da}', formato.format(lavorativi(Number(el.dataset.da) || 3)))
        .replace('{a}', formato.format(lavorativi(Number(el.dataset.a) || 5)));
    });
  }

  /* «Trova il tuo prodotto»: le risposte mostrano il passo dopo e poi la linea, già scritta nella pagina. */
  function trovaMostra(sezione, cosa) {
    tutti('[data-trova-passo="2"]', sezione).forEach(function (p) { p.hidden = cosa.gruppo !== p.dataset.trovaGruppo; });
    tutti('[data-trova-risultato]', sezione).forEach(function (r) { r.hidden = cosa.linea !== r.dataset.trovaRisultato; });
    tutti('.trova__scelta', sezione).forEach(function (s) {
      var scelta = (s.dataset.trovaArea && s.dataset.trovaArea === cosa.gruppo) || (s.dataset.trovaLinea && s.dataset.trovaLinea === cosa.linea);
      s.classList.toggle('scelta', !!scelta);
      if (scelta) s.setAttribute('aria-current', 'true'); else s.removeAttribute('aria-current');
    });
    var bersaglio = cosa.linea ? sezione.querySelector('[data-trova-risultato="' + cosa.linea + '"]')
      : cosa.gruppo ? sezione.querySelector('[data-trova-gruppo="' + cosa.gruppo + '"]') : sezione;
    if (bersaglio && (cosa.linea || cosa.gruppo)) {
      var alto = bersaglio.getBoundingClientRect().top;
      if (alto > window.innerHeight * 0.7 || alto < 0) bersaglio.scrollIntoView({ behavior: movimentoRidotto ? 'auto' : 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (e) {
    var sezione = e.target.closest('[data-trova]');
    if (!sezione) return;
    var area = e.target.closest('[data-trova-area]');
    var linea = e.target.closest('[data-trova-linea]');
    var gruppoAperto = sezione.querySelector('[data-trova-passo="2"]:not([hidden])');
    if (area) { e.preventDefault(); trovaMostra(sezione, { gruppo: area.dataset.trovaArea }); }
    else if (linea && sezione.querySelector('[data-trova-risultato="' + linea.dataset.trovaLinea + '"]')) {
      e.preventDefault();
      trovaMostra(sezione, { linea: linea.dataset.trovaLinea, gruppo: gruppoAperto && linea.closest('[data-trova-gruppo]') ? gruppoAperto.dataset.trovaGruppo : null });
    }
    else if (e.target.closest('[data-trova-indietro]')) trovaMostra(sezione, {});
    else if (e.target.closest('[data-trova-ricomincia]')) {
      trovaMostra(sezione, {});
      sezione.scrollIntoView({ behavior: movimentoRidotto ? 'auto' : 'smooth', block: 'start' });
    }
  });

  function avviaUnaVolta() {
    inclina();
    passaggi();
    benvenuto();
    avvia(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avviaUnaVolta);
  } else {
    avviaUnaVolta();
  }

  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var blocco = e.target;
    var passo = blocco.closest('[data-passo]');
    if (passo) attivaPasso(passo.closest('[data-rituale]'), Number(passo.dataset.passo));
    var recensione = blocco.closest('[data-recensione]');
    if (recensione) {
      var sezione = recensione.closest('[data-recensioni]');
      sezione.classList.add('ferme');
      vaiRecensione(sezione, tutti('[data-recensione]', sezione).indexOf(recensione));
    }
    var punto = blocco.closest('[data-punto]');
    if (punto) apriPunto(punto.closest('[data-punti]'), Number(punto.dataset.punto), false);
  });
})();
